var quizQuestions = [
  {
    question: "Once you get a driver's license, you own it.",
    answers: {
      a: "True",
      b: "False"
    },
    description: "Even after you take a test and pay the fee, you <strong>technically do not own your driver's license</strong>. The State of Oklahoma has the right to cancel, suspend, or revoke your license at any time. Driving is a privilege, and your license simply gives you legal permission to drive.",
    correctAnswer: "b"
  },
  {
    question: "If you are caught driving without a license, how much can you be fined?",
    answers: {
      a: "$250",
      b: "$500",
      c: "$750",
      d: "$1,000"
    },
    description: "Should you drive illegally and without a license you could face a <strong>$500</strong> fine and up to 6 months in jail.",
    correctAnswer: "b"
  },
  {
    question: "If you are involved in a car accident, what information should you gather from the other driver?",
    answers: {
      a: "Name and address",
      b: "Driver license number",
      c: "Vehicle registration number",
      d: "Insurance information",
      e: "All of the above"
    },
    description: "Whether you were at fault or not, <strong>you should gather the name and address of all drivers involved, including the driver's license number, vehicle registration number and insurance information. If the car does not belong to the driver, make sure you get the name and address of the vehicle's owner as well</strong>.",
    correctAnswer: "e"
  },
  {
    question: "When a road sign is green, it generally provides the driver with what information?",
    answers: {
      a: "A regulation",
      b: "Direction guidance",
      c: "A general warning",
      d: "Scenic guidance"
    },
    description: "Green signs usually indicate permitted movements and <strong>directional guidance</strong>. Brown signs, on the other hand, give motorists public recreation information and scenic guidance.",
    correctAnswer: "b"
  },
  {
    question: "What kind of information do diamond-shaped signs usually provide drivers?",
    answers: {
      a: "Directional information",
      b: "School zones",
      c: "Recreational information",
      d: "Warnings"
    },
    description: "A sign shaped like a diamond will provide drivers with some kind of <strong>warning</strong>, usually of approaching hazards and road conditions.",
    correctAnswer: "d"
  },
  {
    question: "When backing up your car, you should always look over your left shoulder.",
    answers: {
      a: "True",
      b: "False"
    },
    description: "Always look over your <strong>right shoulder</strong> when backing up a car.",
    correctAnswer: "b"
  },
  {
    question: "Which of the following signs indicates that cars may pass on either side of an obstruction or traffic island?",
    answers: {
      a: "<img src=\"/images/quiz/quiz1.jpg\" alt=\"Road Sign\" />",
      b: "<img src=\"/images/quiz/quiz2.jpg\" alt=\"Road Sign\" />",
      c: "<img src=\"/images/quiz/quiz3.jpg\" alt=\"Road Sign\" />",
      d: "<img src=\"/images/quiz/quiz4.jpg\" alt=\"Road Sign\" />"
    },
    description: "The sign with two arrows pointing down to the left and right indicates cars may pass on either side of an obstruction or traffic island.",
    correctAnswer: "c"
  },
  {
    question: "What does the following sign mean?<br /><img src=\"/images/quiz/quiz8.jpg\" alt=\"Road Sign\" />",
    answers: {
      a: "Lanes merge ahead",
      b: "Bridge ahead",
      c: "Road narrows ahead",
      d: "Uneven lanes ahead"
    },
    description: "This sign warns that you are approaching a bridge, indicating you should slow down and use caution.",
    correctAnswer: "b"
  },
  {
    question: "You cannot stop within 15 feet of a railroad crossing when crossing gates are lowering or lowered.",
    answers: {
      a: "True",
      b: "False"
    },
    description: "You must stop <strong>between 50 feet and 15 feet</strong> from a railroad crossing when a train is approaching.",
    correctAnswer: "a"
  },
  {
    question: "What does this sign mean?<br /><img src=\"/images/quiz/quiz6.jpg\" alt=\"Road Sign\" />",
    answers: {
      a: "It alerts the driver about a nearing construction zone",
      b: "It is warning of an approaching hazard on the road",
      c: "It's for vehicles that drive less than 25 mph",
      d: "It's for cars with an impaired person behind-the-wheel"
    },
    description: "If a <strong>vehicle that cannot drive above 25 mph is on a public road</strong>, it must display this symbol on its rear.",
    correctAnswer: "c"
  },
  {
    question: "You can pass on a road with a solid yellow line.",
    answers: {
      a: "True",
      b: "False"
    },
    description: "You <strong>cannot pass when a road line is solid</strong>. Rather, you may only pass if the line is striped.",
    correctAnswer: "b"
  },
  {
    question: "When must you yield the right-of-way?",
    answers: {
      a: "When you are turning left",
      b: "When a pedestrian is trying to walk across the street",
      c: "When an emergency vehicle is approaching with its lights on",
      d: "All of the above"
    },
    description: "You must yield the right-of-way when you are <strong>turning left, a pedestrian is trying to walk across the street, and an emergency vehicle is approaching with its lights on</strong>.",
    correctAnswer: "d"
  },
  {
    question: "Most collisions occur at intersections.",
    answers: {
      a: "True",
      b: "False"
    },
    description: "<strong>Intersections can be tricky to navigate, and as a result many accidents occur in them</strong>. Always drive with caution through an intersection, and know that even if you have the right-of-way, another driver may not yield to you.",
    correctAnswer: "a"
  },
  {
    question: "When you are on a two-lane highway and see a solid white line, what does that line mean?",
    answers: {
      a: "You cannot pass",
      b: "Passing is okay, but proceed with caution",
      c: "It's just a highway divider to help drivers stay in a lane but it doesn't mean anything",
      d: "It lets you know you're on a freeway"
    },
    description: "A solid white line on a multiple-lane road <strong>indicates that while it is legal to switch between lanes, you should do so with caution</strong>. These lines are typically seen when approaching a bend in the road, intersection, or etc.",
    correctAnswer: "b"
  },
  {
    question: "You can never get a citation for driving under the speed limit.",
    answers: {
      a: "True",
      b: "False"
    },
    description: "If you are driving far below the speed limit, <strong>you may be considered an obstruction of traffic and given a ticket</strong>.",
    correctAnswer: "b"
  },
  {
    question: "You should look 10-15 seconds ahead of your car in order to spot potential hazards.",
    answers: {
      a: "True",
      b: "False"
    },
    description: "When you're driving, try to scan at least <strong>15-20 seconds ahead</strong> of your car in order to spot potential hazards.",
    correctAnswer: "b"
  },
  {
    question: "It is illegal to turn without a signal.",
    answers: {
      a: "True",
      b: "False"
    },
    description: "Should you turn without using your signal, you may end up receiving a traffic citation since, <strong>by law, you must use the signal</strong>.",
    correctAnswer: "a"
  },
  {
    question: "To hand signal a left turn, you must stick your arm straight out.",
    answers: {
      a: "True",
      b: "False"
    },
    description: "To signal left, <strong>you stick your arm straight out</strong>; to signal right, you stick your arm up, keeping your elbow straight; to signal a stop, you point your arm down.",
    correctAnswer: "a"
  },
  {
    question: "Unless otherwise posted, school zones in Oklahoma have a speed limit of:",
    answers: {
      a: "20 mph",
      b: "25 mph",
      c: "30 mph",
      d: "35 mph"
    },
    description: "The state has standard speed limits set for certain areas and types of roads. For school zones, this speed limit is <strong>35 mph</strong>. However, local governments have the right to adjust these speeds.",
    correctAnswer: "d"
  },
  {
    question: "If you're driving at 50 mph, how many feet does it take a car to stop during normal weather conditions?",
    answers: {
      a: "99-116 feet",
      b: "141-195 feet",
      c: "193-277 feet",
      d: "252-372 feet"
    },
    description: "If you consider how long it takes a driver to see and then react to danger, then factor in how long it physically takes for a car to stop, it takes around <strong>193-277</strong> feet for a car traveling at 50 mph to come to a complete stop.",
    correctAnswer: "c"
  }
];
